import React, { FC, PropsWithChildren } from 'react';

import { connectorsForWallets } from '@rainbow-me/rainbowkit';
import '@rainbow-me/rainbowkit/styles.css';
import {
  injectedWallet,
  metaMaskWallet,
  rabbyWallet,
  safeWallet,
  walletConnectWallet,
} from '@rainbow-me/rainbowkit/wallets';
import { fallback } from '@wagmi/core';
import { Transport } from 'viem';
import { WagmiProvider, createConfig, http } from 'wagmi';
import { Chain, base } from 'wagmi/chains';

import { CHAINS_RPC, CHAIN_ID } from '@constants/common/chain.constants';

const connectors = connectorsForWallets(
  [
    {
      groupName: 'Recommended',
      wallets: [
        metaMaskWallet,
        rabbyWallet,
        walletConnectWallet,
        injectedWallet,
        safeWallet,
      ],
    },
  ],
  {
    appName: 'HitTheYield',
    projectId: 'b64bb571a8481ceacede5562d595bcbd',
  },
);

const chains: [Chain, ...Chain[]] = [base];

const transports = chains.reduce(
  (acc, chain) => {
    const httpStrings: string[] | readonly string[] = CHAINS_RPC[
      chain.id as CHAIN_ID
    ]
      ? CHAINS_RPC[chain.id as CHAIN_ID]
      : [];

    return {
      ...acc,
      [chain.id]: fallback(httpStrings.map((item) => http(item))),
    };
  },
  {} as Record<number, Transport>,
);

export const CLIENT_CONFIG = {
  batch: {
    multicall: {
      batchSize: 1024 * 200,
      wait: 16,
    },
  },
  pollingInterval: 6_000,
};

export const config = createConfig({
  chains,
  syncConnectedChain: true,
  transports,
  ssr: true,
  ...CLIENT_CONFIG,
  connectors,
});

const chainIdTuple = [...new Set(chains.map((chain) => chain.id))] as const;

export type ConfigChainIds = (typeof chainIdTuple)[number];

export const Wagmi: FC<PropsWithChildren> = ({ children }) => (
  <WagmiProvider config={config}>{children}</WagmiProvider>
);
